import { checkBankCard } from '../../helpers/CheckFunctions.js';

export default {
    updateFields(documentData, context) {
        return;
    },

    checkInputPage(documentData) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        if (result && !documentData.properties["sx:dPhoneNum"]) {
            result = false;
            errorElementName = "sx:dPhoneNum";
        }
        if (result && !documentData.properties["sx:dBank"]) {
            result = false;
            errorElementName = "sx:dBank";
        }
        if (result && !checkBankCard(documentData.properties["sx:dCardNum"])) {
            result = false;
            errorElementName = "sx:dCardNum";
        }
        
        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}